export default __webpack_public_path__ + "assets/images/7073e5e58f182215a6b1c3b6e53dec40.png";